var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39844 7.00039C1.39844 8.4856 1.98844 9.90999 3.03864 10.9602C4.08884 12.0104 5.51323 12.6004 6.99844 12.6004C8.48365 12.6004 9.90803 12.0104 10.9582 10.9602C12.0084 9.90999 12.5984 8.4856 12.5984 7.00039C12.5984 5.51518 12.0084 4.0908 10.9582 3.04059C9.90803 1.99039 8.48365 1.40039 6.99844 1.40039C5.51323 1.40039 4.08884 1.99039 3.03864 3.04059C1.98844 4.0908 1.39844 5.51518 1.39844 7.00039V7.00039Z",
    stroke: "#E74343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28222 7.13789C6.28222 7.5521 6.61801 7.88789 7.03222 7.88789C7.44643 7.88789 7.78222 7.5521 7.78222 7.13789L7.78222 4.33789C7.78222 3.92368 7.44644 3.58789 7.03222 3.58789C6.61801 3.58789 6.28222 3.92368 6.28222 4.33789L6.28222 7.13789ZM7.54854 10.388C7.39103 10.4933 7.20585 10.5495 7.01641 10.5495C6.76238 10.5495 6.51876 10.4486 6.33913 10.2689C6.1595 10.0893 6.05859 9.84567 6.05859 9.59165C6.05859 9.40222 6.11477 9.21703 6.22001 9.05951C6.32526 8.902 6.47485 8.77924 6.64987 8.70674C6.82489 8.63425 7.01747 8.61528 7.20327 8.65224C7.38906 8.68919 7.55973 8.78041 7.69369 8.91437C7.82764 9.04833 7.91886 9.21899 7.95582 9.40479C7.99278 9.59058 7.97381 9.78317 7.90132 9.95819C7.82882 10.1332 7.70606 10.2828 7.54854 10.388Z",
    fill: "#E74343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedError);
export default __webpack_public_path__ + "static/media/icon-red-error.71bad48b9d3409ceb87982106d3e4d5c.svg";
export { ForwardRef as ReactComponent };